import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { useNotification } from '../store/hooks';

import { getErrorData, isExcludedError } from './utils';

function handleError(error) {
  const errorData = getErrorData(error.response?.data?.error?.type);
  const noToastErrorTypes = ['ERR_CANCELED', 'OrganizationAlreadyPendingForApproval'];

  if (
    !isExcludedError(error) &&
    !noToastErrorTypes.includes(error?.code || error?.response?.data?.error?.type)
  ) {
    useNotification.getState().showError({
      title: errorData.title,
      message: errorData.message,
      icon: 'error',
      type: errorData.type,
      ...(errorData.type === 'toast'
        ? {
            toastOptions: {
              duration: Infinity
            }
          }
        : {})
    });
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      staleTime: 0,
      retryDelay: 10 * 1000,
      retry: 1,
      refetchOnWindowFocus: false
    }
  },
  queryCache: new QueryCache({
    onError: handleError
  }),
  mutationCache: new MutationCache({
    onError: handleError
  })
});
